import { Button } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

interface ContainerProps {
  $clickable: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 8px;
  border-radius: 8px;
  font-family: 'Rubik';
  background-color: ${COLOR_OPTIONS.NEUTRAL_00};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  line-height: 22px;
  color: ${COLOR_OPTIONS.NEUTRAL_100};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
`;

export const TitleText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const HeaderDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const IconText = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 15px;
  color: ${COLOR_OPTIONS.NEUTRAL_70};
`;

export const DiseasesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 10px 2px 10px;
  background-color: ${COLOR_OPTIONS.WHITE};
  border-top: 1px solid ${COLOR_OPTIONS.NEUTRAL_30};
  min-height: 42px;
`;

export const DetailsLink = styled(Button)`
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${COLOR_OPTIONS.BLUE_60};
  padding: 0;
  height: auto;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;

  &:hover {
    color: ${COLOR_OPTIONS.BLUE_70};
    text-decoration: underline;
  }
`;
